/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysquePropertiesListModule } from '../../../../../../../shared/ui/src/lib/components/sysque-properties-list';
import { SysqueNumberBoxOptionsLineModule } from '../../../../../../../shared/ui/src/lib/components/sysque-number-box-options-line';
import { SysqueDropdownConnectorsModule } from '../../../../../../../shared/ui/src/lib/components/sysque-dropdown-connectors';
import { SysqueToggleButtonModule } from '../../../../../../../shared/ui/src/lib/components/sysque-switch-button';
import { SysqueTextBoxDescriptionModule } from '../../../../../../../shared/ui/src/lib/components/sysque-text-area-description';
import { DxButtonModule } from 'devextreme-angular';
import { RouterModule, Routes } from '@angular/router';
import { UserCustomContentFamilyInformation } from './user-custom-content-family-information.component';
import { SysquePdfLocationModule } from 'libs/sysque/shared/ui/src/lib/components/sysque-pdf-location';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [
  { path: 'dialog/user-custom-content-family-information-dialog', component: UserCustomContentFamilyInformation },
];

@NgModule({
  declarations: [UserCustomContentFamilyInformation],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SysquePropertiesListModule,
    SysqueNumberBoxOptionsLineModule,
    SysqueTextBoxDescriptionModule,
    SysqueToggleButtonModule,
    SysqueDropdownConnectorsModule,
    SysquePdfLocationModule,
    AlertModule,
    DxButtonModule
  ],
  exports: [UserCustomContentFamilyInformation],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserCustomContentFamilyInformationModule {}